import * as React from 'react';
import RootAtom from './Root';
import { NodeTypes } from '@src/interfaces/nodes';
import Atoms from '@src/interpreter/_Atoms';
function RootElement({ component, parent, tilted, index }) {
    if (component.type === NodeTypes.Root) {
        return (React.createElement(RootAtom, { component: component, tilted: tilted, index: index }, Object.values(component.children).map((node, subIndex) => (React.createElement(Atoms, { key: parent ? parent.id + node.id : node.id, component: node, parent: parent, tilted: false, index: subIndex })))));
    }
}
export default RootElement;
